import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "highcharts/highcharts-3d"; // registers automatically

import Card from "react-bootstrap/Card";

export default function ComplimentarySalesColumnChart({ data }) {
  const options = {
    chart: {
      backgroundColor: "none",
      renderTo: "container",
      type: "column",
      options3d: {
        enabled: true,
        alpha: 15,
        beta: 15,
        depth: 50,
        viewDistance: 25,
      },
    },
    credits: {
      enabled: false,
    },
    title: {
      text: "",
    },
    xAxis: {
      type: "category",
    },
    yAxis: {
      title: {
        enabled: false,
      },
    },
    tooltip: {
      headerFormat: "<b>{point.key}</b><br>",
      pointFormat: "Assigned: <b>{point.y}</b>",
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      column: {
        depth: 25,
      },
    },
    series: [
      {
        data: data,
        colorByPoint: true,
      },
    ],
  };

  return (
    <Card body className="card--md card-with-border">
      <div className="card-body-heading card-body-heading--sm">
        <Card.Title as="h5">
          Complementary tickets assigned by category
        </Card.Title>
        <Card.Subtitle as="h6" className="mt-2">
          Detailed breakdown showing comp tickets assigned by category
        </Card.Subtitle>
      </div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Card>
  );
}
